
const digest = '3f38a5f9b8f6b3bc78224c71231ed0c0ccb63f9bf008e1a65e44fdb9d46b7db7';
const classes = {"wrapper":"_wrapper_1xbyk_1","green":"_green_1xbyk_13","orange":"_orange_1xbyk_18","gray":"_gray_1xbyk_23","red":"_red_1xbyk_28"};
const css = `._wrapper_1xbyk_1 {
  display: inline-block;
  width: fit-content;
  max-width: 100%;
  font-size: inherit;
  font-weight: 500;
  line-height: 1.2;
  padding: 4px 8px;
  border-radius: 4px;
  white-space: nowrap;
}

._green_1xbyk_13 {
  background-color: #619612;
  color: #fff;
}

._orange_1xbyk_18 {
  background-color: #f27114;
  color: #fff;
}

._gray_1xbyk_23 {
  background-color: #afb6ca;
  color: #fff;
}

._red_1xbyk_28 {
  background-color: #f12848;
  color: #fff;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  